namespace $ {

	$mol_style_attach( '$shm_dotsloader_animation', `
		@keyframes shm_dotsloader_dot {
			0%, 40%, 100% { opacity: .25; transform: translateY(0); }
			20% { opacity: 1; transform: translateY(-.2rem); }
		}
	` )

	$mol_style_define( $shm_dotsloader, {
		flex: { shrink: 0 },
		align: { items: 'center' },
		gap: '0.3rem',
		Dot_first: {
			width: '0.5rem',
			height: '0.5rem',
			border: { radius: '50%' },
			background: { color: $mol_theme.shade },
			animation: { name: 'shm_dotsloader_dot', duration: '1.2s', iterationCount: 'infinite' },
		},
		Dot_second: {
			width: '0.5rem',
			height: '0.5rem',
			border: { radius: '50%' },
			background: { color: $mol_theme.shade },
			animation: { name: 'shm_dotsloader_dot', duration: '1.2s', delay: '.15s', iterationCount: 'infinite' },
		},
		Dot_third: {
			width: '0.5rem',
			height: '0.5rem',
			border: { radius: '50%' },
			background: { color: $mol_theme.shade },
			animation: { name: 'shm_dotsloader_dot', duration: '1.2s', delay: '.3s', iterationCount: 'infinite' },
		},
	} )

}
